import moment from 'moment';

const SERVER_TIMESTAMP_FORMATS = [
  'YYYY-MM-DD HH:mm:ss.SSS ZZ',
  'YYYY-MM-DD HH:mm:ss ZZ',
  'YYYY-MM-DD HH:mm:ss.SSS Z',
  'YYYY-MM-DD HH:mm:ss Z',
  'YYYY-MM-DDTHH:mm:ss.SSS ZZ',
  'YYYY-MM-DDTHH:mm:ss ZZ',
  'YYYY-MM-DDTHH:mm:ss.SSS Z',
  'YYYY-MM-DDTHH:mm:ss Z',
];

const parseTimestamp = (value) => {
  if (!value) return null;

  if (moment.isMoment(value)) return value.clone();

  if (value instanceof Date || typeof value === 'number') {
    const direct = moment(value);
    return direct.isValid() ? direct : null;
  }

  if (typeof value !== 'string') return null;

  const raw = value.trim();
  if (!raw) return null;

  const strictKnown = moment(raw, SERVER_TIMESTAMP_FORMATS, true);
  if (strictKnown.isValid()) return strictKnown;

  const strictIso = moment(raw, moment.ISO_8601, true);
  if (strictIso.isValid()) return strictIso;

  return null;
};

const formatTimestamp = (value, format, fallback = '-') => {
  const parsed = parseTimestamp(value);
  if (!parsed) return fallback;
  return parsed.format(format);
};

export { parseTimestamp, formatTimestamp };
